var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2364,
    height: 1046,
    transform: "translate(-192 -314)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 14C17.5798 14 17.1898 14.08 16.8098 14.2L15.0198 12.29L18.8498 8.78002C18.9998 8.64002 19.1098 8.45002 19.1598 8.25002L20.2898 3.40002C20.4198 2.84002 20.0998 2.28002 19.5598 2.08002C19.1198 1.91002 18.6498 2.01002 18.3298 2.35002L12.0098 9.09002L5.67977 2.35002C5.35977 2.01002 4.87977 1.91002 4.44977 2.08002C3.91977 2.29002 3.58977 2.84002 3.71977 3.40002L4.84977 8.25002C4.89977 8.45002 5.00977 8.64002 5.15977 8.78002L8.98977 12.29L7.19977 14.2C6.81977 14.08 6.42977 14 6.00977 14C3.79977 14 2.00977 15.79 2.00977 18C2.00977 20.21 3.79977 22 6.00977 22C8.21977 22 10.0098 20.21 10.0098 18C10.0098 17.66 9.94977 17.33 9.86977 17.01L12.0098 15.04L14.1498 17.01C14.0698 17.33 14.0098 17.65 14.0098 18C14.0098 20.21 15.7998 22 18.0098 22C20.2198 22 22.0098 20.21 22.0098 18C22.0098 15.79 20.2198 14 18.0098 14H17.9998ZM5.99977 20C4.89977 20 3.99977 19.1 3.99977 18C3.99977 16.9 4.89977 16 5.99977 16C7.09977 16 7.99977 16.9 7.99977 18C7.99977 19.1 7.09977 20 5.99977 20ZM11.9998 13C11.4498 13 10.9998 12.55 10.9998 12C10.9998 11.45 11.4498 11 11.9998 11C12.5498 11 12.9998 11.45 12.9998 12C12.9998 12.55 12.5498 13 11.9998 13ZM17.9998 20C16.8998 20 15.9998 19.1 15.9998 18C15.9998 16.9 16.8998 16 17.9998 16C19.0998 16 19.9998 16.9 19.9998 18C19.9998 19.1 19.0998 20 17.9998 20Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCut);
export default __webpack_public_path__ + "static/media/icon-cut.f5a4620c7830ffd27a898cae70b792be.svg";
export { ForwardRef as ReactComponent };